import { Porter } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { datadogLogs } from '@datadog/browser-logs';
import { getFaresQuery } from './get-fares-query';

export const getFaresQueryOptions = (porter?: Porter) => {
  return queryOptions({
    queryKey: [getFaresQuery(porter).className, getFaresQuery(porter).toJSON()],
    queryFn: () => {
      datadogLogs.logger.debug('TANSTACK_DEBUG: TanStack Query executing getFares query', {
        porterId: porter?.id,
        queryKey: [getFaresQuery(porter).className, getFaresQuery(porter).toJSON()],
        timestamp: Date.now(),
        source: 'tanstack-query-refetch',
      });
      return getFaresQuery(porter).find();
    },
    enabled: !!porter,
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
};
